import React, { useState, useEffect, useContext } from "react";
import { GlobalContext } from "../../../context/Provider";
import CruzIcon from "../../../../_+_Portal/assets/images/generico/CruzIcon";
import { BackgroundModalAlerta, ContainerModalAlerta } from "./localStyle";
import { hideModalAlerta } from "../../../context/action/modal/modalAlerta";
import TildeIcon from "../../../../_+_Portal/assets/images/generico/TildeIcon";

const ModalAlerta = () => {
  const { modalAlertaState, modalAlertaDispatch } = useContext(GlobalContext);
  const [bloquearDismiss, setBloquearDismiss] = useState(true);
  const [type, setType] = useState(false);

  const dissmiss = () => {
    if (!bloquearDismiss) {
      hideModalAlerta()(modalAlertaDispatch);
    }
  };

  useEffect(() => {
    setBloquearDismiss(modalAlertaState.modalAlerta.data.bloquearDismiss);
    if (modalAlertaState.modalAlerta.data.type === "success") {
      setType(false);
    } else {
      setType(true);
    }
  }, []);

  return (
    <>
      <BackgroundModalAlerta onClick={dissmiss} />
      <ContainerModalAlerta className={type ? "bgc-danger" : "bgc-broccoli"}>
        <div className="cruz-circle">
          {type ? (
            <CruzIcon color={"white"} height={"20"} width={"20"} />
          ) : (
            <TildeIcon color={"white"} height={"20"} width={"20"} />
          )}
        </div>
        <p
          dangerouslySetInnerHTML={{
            __html: modalAlertaState.modalAlerta.data.text,
          }}
        />
        <button onClick={modalAlertaState.modalAlerta.data.accion}>
          Aceptar
        </button>
      </ContainerModalAlerta>
    </>
  );
};
export default ModalAlerta;
